export const SHOW_PARTNERSHIPS = false;
